import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

var router = new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "index",
      component: (resolve) =>
        require(["@/components/IndexMobile.vue"], resolve),
    },
  ],
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js